import React, { useState, useEffect } from "react";
import "./ComponentRowByDestination.css";
import "../../../../pages/CustomPackageDetails/CustomPackageDetails";
import remove from "../../../../assets/images/packages/svg/remove.svg";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useTranslation } from "../../../../contexts/TranslationContext";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const ComponentRowByDestination = ({
  quotationData,
  destination,
  nights,
  onNightsChange,
  startDate,
  endDate,
  isLast,
  openAddHotel,
  onRemoveHotel,
  onShowHotel,
  openAddFlight,
  openAddTour,
  openAddService,
  openAddTransportation,
  setSelectedComponent,
  setShowManualHotelForm,
  setShowManualFlightForm,
  setDeleteModal,
  saveBaseData,
  onClickShowAll,
  onClickShowAllType,
  disabled,
  setDeletedRowId,
  bookWarnings,
}) => {
  const [HotelItem, setHotelItem] = useState(null);
  const [hasServices, setHasServices] = useState(null);
  const [hasTrasportation, setHasTransportation] = useState(null);
  const [hasActivity, setHasActivity] = useState(null);
  const [hasFlight, setHasFlight] = useState(null);
  const [hasHotel, setHasHotel] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedComponent(null);
  }, []);

  useEffect(() => {
    if (quotationData?.items && destination?.location && startDate && endDate) {
      let hasServiceComp = false;
      let hasTransportationComp = false;
      let hasActivityComp = false;
      let hasFlightComp = false;
      let hasHotelComp = false;

      const serviceTypes = [ "Service", "Visa Reservation", "Insurance Reservation", "IDL Reservation" ];

      for (const item of quotationData.items) {
        const isMatch = item.destination_row_id === destination.primary_destination_row_id;
        //  &&
        // dayjs(item.date_from).isSameOrAfter(dayjs(startDate), "day") &&
        // dayjs(item.date_from).isSameOrBefore(dayjs(endDate), "day");

        if (!isMatch) continue;

      if (serviceTypes.includes(item.package_component_type)) {
      hasServiceComp = true;
      }
  else if (item.package_component_type === "Transportation") {
          hasTransportationComp = true;
        } else if (item.package_component_type === "All Time Activity") {
          hasActivityComp = true;
        } else if (
          item.package_component_type === "Hotel" ||
          item.package_component_type === "Hotel Reservation"
        ) {
          hasHotelComp = true;
          setHotelItem(item);
        } else if (
          item.package_component_type === "Flight" ||
          item.package_component_type === "Flight Reservation"
        ) {
          hasFlightComp = true;
        }
        // Early exit if all found
        if (hasServiceComp && hasTransportationComp && hasActivityComp && hasHotelComp && hasFlightComp) break;
      }

      setHasServices(hasServiceComp);
      setHasTransportation(hasTransportationComp);
      setHasActivity(hasActivityComp);
      setHasHotel(hasHotelComp);
      setHasFlight(hasFlightComp);
    }
  }, [quotationData, nights]);

  const NightCounter = ({ nights, onUpdate, disabled }) => (
    <div className="night-counter">
      <button
        onClick={() => !disabled && onUpdate(-1)}
        className="add-night-btn"
        disabled={disabled}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="2"
          viewBox="0 0 7 2"
          fill="none"
        >
          <path d="M0 1.808V0H6.752V1.808H0Z" fill="#5A5A5A" />
        </svg>
      </button>
      <div className="night-number">{nights}</div>
      <button
        onClick={() => !disabled && onUpdate(1)}
        className="add-night-btn"
        disabled={disabled}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
        >
          <path
            d="M2.992 7.296V0H4.832V7.296H2.992ZM0 4.544V2.736H7.808V4.544H0Z"
            fill="#5A5A5A"
          />
        </svg>
      </button>
    </div>
  );

  const AddItemButton = ({ onAdd }) => (
    <button
      className={`table-add-field ${disabled ? "table-add-field-disable" : ""}`}
      onClick={onAdd}
      disabled={disabled}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
      >
        <path
          d="M2.992 7.296V0H4.832V7.296H2.992ZM0 4.544V2.736H7.808V4.544H0Z"
          fill="white"
        />
      </svg>
    </button>
  );



  return (
    <div className="maindashboard-table-row">
      <div className="maindashboard-table-cell first-cell">
        <div className="destination-container">
          <div
            className="destination-id"
            style={{ background: "#ed4b5c26", cursor: "pointer" }}
            onClick={() => {
              setDeletedRowId();
              setDeleteModal(true);
            }}
          >
            <img
              src={remove}
              alt="remove"
            ></img>
          </div>
          <div className="destination-id">{destination.idx}</div>

          <div className="destination-meta">
            <div className="maindashboard-destination-title">
              {destination.location_name}
            </div>
            <div className="destination-date">
              {dayjs(startDate).format("MMM D")} -{" "}
              {dayjs(endDate).format("MMM D")}
            </div>
          </div>
        </div>
      </div>

      <div className="maindashboard-table-cell">
        {/* {!isLast ? ( */}
        <NightCounter
          nights={nights}
          onUpdate={(delta) => onNightsChange(destination.idx, delta)}
        />
        {/* // ) */}
        {/* //  : ( */}
        {/* //   <div className="night-number">{nights}</div> */}
        {/* // ) */}
        {/* } */}
      </div>

      <div className="maindashboard-table-cell">
        {hasHotel ? (
          <div className="selected-hotel-container">
            <div className="selected-hotel-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M9.82982 0.943928L3.6778 6.83749C3.62421 6.889 3.56054 6.92987 3.49044 6.95776C3.42033 6.98564 3.34517 7 3.26926 7C3.19335 7 3.11819 6.98564 3.04809 6.95776C2.97798 6.92987 2.91431 6.889 2.86073 6.83749L0.16922 4.25906C0.115571 4.20766 0.0730136 4.14665 0.0439788 4.0795C0.014944 4.01234 7.99437e-10 3.94037 0 3.86769C-7.99437e-10 3.795 0.014944 3.72303 0.0439788 3.65588C0.0730136 3.58873 0.115571 3.52771 0.16922 3.47632C0.222869 3.42492 0.28656 3.38415 0.356656 3.35634C0.426752 3.32852 0.501881 3.31421 0.577753 3.31421C0.653624 3.31421 0.728753 3.32852 0.798849 3.35634C0.868945 3.38415 0.932636 3.42492 0.986286 3.47632L3.26974 5.66384L9.01371 0.16211C9.12206 0.0583128 9.26902 0 9.42225 0C9.57548 0 9.72243 0.0583128 9.83078 0.16211C9.93913 0.265908 10 0.406688 10 0.55348C10 0.700272 9.93817 0.840131 9.82982 0.943928Z"
                  fill="#61AF64"
                />
              </svg>
            </div>
            <div className="selected-hotel-title">{t("HotelSelected")} <span>
            {bookWarnings?.find(item =>
              (item?.package_component_type?.includes("Hotel")) &&
              item?.destination_row_id === destination?.primary_destination_row_id
            ) ? "⚠︎" : ""}
                  </span></div>
            <div className="hotel-action-buttons">
              <button
                className={`hotel-action-btn view-btn ${
                  bookWarnings.length !== 0 ? "show-color" : ""
                }`}
                disabled={bookWarnings.length === 0 && disabled}
                onClick={() => {
                  if (!HotelItem.already_reserved) {
                    onClickShowAll();
                    saveBaseData();
                    onClickShowAllType("Hotel");
                    // onShowHotel(hotel, destination.idx, true);
                  } else {
                    onClickShowAll();
                    saveBaseData();
                    onClickShowAllType("Hotel");
                  }

                  // if (!HotelItem.already_reserved) {
                  //   onShowHotel(hotel, destination.idx, true);
                  // } else {
                  //   setSelectedComponent({
                  //     component_id: HotelItem.package_component_id,
                  //     component_type: "Hotel Reservation",
                  //   });
                  //   saveBaseData();
                  //   setShowManualHotelForm(true);
                  // }
                }}
              >
                {t("Show")}
              </button>
              {/* <button
                className="hotel-action-btn remove-btn"
                onClick={() => {
                  setSelectedComponent({
                    component_id: HotelItem.package_component_id,
                    component_type: "Hotel Reservation",
                  });
                  setDeleteModal(true);
                }}
              >
                {t("Remove")}
              </button> */}
              <button
                className="hotel-action-btn view-btn"
                disabled={disabled}
                onClick={() => {
                  setSelectedComponent(null);
                  openAddHotel(destination.idx);
                }}
              >
                {t("Add")}
              </button>
            </div>
          </div>
        ) : (
          <AddItemButton
            onAdd={() => {
              setSelectedComponent(null);
              openAddHotel(destination.idx);
            }}
          />
        )}
      </div>

      <div className="maindashboard-table-cell">
        {hasFlight ? (
          <div className="selected-hotel-container">
            <div className="selected-hotel-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M9.82982 0.943928L3.6778 6.83749C3.62421 6.889 3.56054 6.92987 3.49044 6.95776C3.42033 6.98564 3.34517 7 3.26926 7C3.19335 7 3.11819 6.98564 3.04809 6.95776C2.97798 6.92987 2.91431 6.889 2.86073 6.83749L0.16922 4.25906C0.115571 4.20766 0.0730136 4.14665 0.0439788 4.0795C0.014944 4.01234 7.99437e-10 3.94037 0 3.86769C-7.99437e-10 3.795 0.014944 3.72303 0.0439788 3.65588C0.0730136 3.58873 0.115571 3.52771 0.16922 3.47632C0.222869 3.42492 0.28656 3.38415 0.356656 3.35634C0.426752 3.32852 0.501881 3.31421 0.577753 3.31421C0.653624 3.31421 0.728753 3.32852 0.798849 3.35634C0.868945 3.38415 0.932636 3.42492 0.986286 3.47632L3.26974 5.66384L9.01371 0.16211C9.12206 0.0583128 9.26902 0 9.42225 0C9.57548 0 9.72243 0.0583128 9.83078 0.16211C9.93913 0.265908 10 0.406688 10 0.55348C10 0.700272 9.93817 0.840131 9.82982 0.943928Z"
                  fill="#61AF64"
                />
              </svg>
            </div>
            <div className="selected-hotel-title">{t("FlightSelected")}
            <span>
            {bookWarnings?.find(item =>
              (item?.package_component_type?.includes("Flight")) &&
              item?.destination_row_id === destination?.primary_destination_row_id
            ) ? "⚠︎" : ""}
          </span>
            </div>
            
            
            <div className="hotel-action-buttons">
              <button
                className={`hotel-action-btn view-btn ${
                  bookWarnings.length !== 0 ? "show-color" : ""
                }`}
                disabled={bookWarnings.length === 0 && disabled}
                onClick={() => {
                  onClickShowAll();
                  saveBaseData();
                  onClickShowAllType("Flight");
                  // if (!FlightItem.already_reserved) {
                  // } else {
                  //   saveBaseData();
                  //   setSelectedComponent({
                  //     component_id: FlightItem.package_component_id,
                  //     component_type: "Flight Reservation",
                  //   });
                  //   setShowManualFlightForm(true);
                  // }
                }}
              >
                {t("Show")}
              </button>
              {/* <button
                className="hotel-action-btn remove-btn"
                onClick={() => {
                  setSelectedComponent({
                    component_id: FlightItem.package_component_id,
                    component_type: "Flight Reservation",
                  });
                  setDeleteModal(true);
                }}
              >
                {t("Remove")}
              </button> */}
              <button
                className="hotel-action-btn view-btn"
                disabled={disabled}
                onClick={() => {
                  setSelectedComponent(null);
                  openAddFlight(destination.idx);
                }}
              >
                {t("Add")}
              </button>
            </div>
          </div>
        ) : (
          <AddItemButton
            onAdd={() => {
              setSelectedComponent(null);
              openAddFlight(destination.idx);
            }}
          />
        )}
      </div>

      <div className="maindashboard-table-cell">
        {hasTrasportation ? (
          <div className="selected-hotel-container">
            <div className="selected-hotel-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M9.82982 0.943928L3.6778 6.83749C3.62421 6.889 3.56054 6.92987 3.49044 6.95776C3.42033 6.98564 3.34517 7 3.26926 7C3.19335 7 3.11819 6.98564 3.04809 6.95776C2.97798 6.92987 2.91431 6.889 2.86073 6.83749L0.16922 4.25906C0.115571 4.20766 0.0730136 4.14665 0.0439788 4.0795C0.014944 4.01234 7.99437e-10 3.94037 0 3.86769C-7.99437e-10 3.795 0.014944 3.72303 0.0439788 3.65588C0.0730136 3.58873 0.115571 3.52771 0.16922 3.47632C0.222869 3.42492 0.28656 3.38415 0.356656 3.35634C0.426752 3.32852 0.501881 3.31421 0.577753 3.31421C0.653624 3.31421 0.728753 3.32852 0.798849 3.35634C0.868945 3.38415 0.932636 3.42492 0.986286 3.47632L3.26974 5.66384L9.01371 0.16211C9.12206 0.0583128 9.26902 0 9.42225 0C9.57548 0 9.72243 0.0583128 9.83078 0.16211C9.93913 0.265908 10 0.406688 10 0.55348C10 0.700272 9.93817 0.840131 9.82982 0.943928Z"
                  fill="#61AF64"
                />
              </svg>
            </div>
            <div className="selected-hotel-title">
              {t("TransportsSelected")}
              <span>
            {bookWarnings?.find(item =>
              (item?.package_component_type?.includes("Transportation")) &&
              item?.destination_row_id === destination?.primary_destination_row_id
            ) ? "⚠︎" : ""}
          </span>
            </div>
            <div className="hotel-action-buttons">
              <button
                className={`hotel-action-btn view-btn ${
                  bookWarnings.length !== 0 ? "show-color" : ""
                }`}
                disabled={bookWarnings.length === 0 && disabled}
                onClick={() => {
                  onClickShowAll();
                  saveBaseData();
                  onClickShowAllType("Transportation");
                }}
              >
                {t("Show")}
              </button>
              <button
                className="hotel-action-btn view-btn"
                disabled={disabled}
                onClick={() => {
                  setSelectedComponent(null);
                  openAddTransportation(destination.idx);
                }}
              >
                {t("Add")}
              </button>
            </div>
          </div>
        ) : (
          <AddItemButton onAdd={() => {
            setSelectedComponent(null);
            openAddTransportation(destination.idx)
          }} />
        )}
      </div>

      <div className="maindashboard-table-cell">
        {hasActivity ? (
          <div className="selected-hotel-container">
            <div className="selected-hotel-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M9.82982 0.943928L3.6778 6.83749C3.62421 6.889 3.56054 6.92987 3.49044 6.95776C3.42033 6.98564 3.34517 7 3.26926 7C3.19335 7 3.11819 6.98564 3.04809 6.95776C2.97798 6.92987 2.91431 6.889 2.86073 6.83749L0.16922 4.25906C0.115571 4.20766 0.0730136 4.14665 0.0439788 4.0795C0.014944 4.01234 7.99437e-10 3.94037 0 3.86769C-7.99437e-10 3.795 0.014944 3.72303 0.0439788 3.65588C0.0730136 3.58873 0.115571 3.52771 0.16922 3.47632C0.222869 3.42492 0.28656 3.38415 0.356656 3.35634C0.426752 3.32852 0.501881 3.31421 0.577753 3.31421C0.653624 3.31421 0.728753 3.32852 0.798849 3.35634C0.868945 3.38415 0.932636 3.42492 0.986286 3.47632L3.26974 5.66384L9.01371 0.16211C9.12206 0.0583128 9.26902 0 9.42225 0C9.57548 0 9.72243 0.0583128 9.83078 0.16211C9.93913 0.265908 10 0.406688 10 0.55348C10 0.700272 9.93817 0.840131 9.82982 0.943928Z"
                  fill="#61AF64"
                />
              </svg>
            </div>
            <div className="selected-hotel-title">{t("ActivitySelected")}
            <span>
            {bookWarnings?.find(item =>
              (item?.package_component_type?.includes("Activity")) &&
              item?.destination_row_id === destination?.primary_destination_row_id
            ) ? "⚠︎" : ""}
          </span>

            </div>
            <div className="hotel-action-buttons">
              <button
                className={`hotel-action-btn view-btn ${
                  bookWarnings.length !== 0 ? "show-color" : ""
                }`}
                disabled={bookWarnings.length === 0 && disabled}
                onClick={() => {
                  // openAddTour(destination.idx);
                  onClickShowAll();
                  saveBaseData();
                  onClickShowAllType("All Time Activity");
                }}
                // disabled={disabled}
              >
                {t("Show")}
              </button>
              <button
                className="hotel-action-btn view-btn"
                disabled={disabled}
                onClick={() => {
                  setSelectedComponent(null);
                  openAddTour(destination.idx);
                }}
              >
                {t("Add")}
              </button>
            </div>
          </div>
        ) : (
          <AddItemButton onAdd={() => {
            setSelectedComponent(null);
            openAddTour(destination.idx)}} />
        )}
      </div>

      <div className="maindashboard-table-cell">
        {hasServices ? (
          <div className="selected-hotel-container">
            <div className="selected-hotel-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M9.82982 0.943928L3.6778 6.83749C3.62421 6.889 3.56054 6.92987 3.49044 6.95776C3.42033 6.98564 3.34517 7 3.26926 7C3.19335 7 3.11819 6.98564 3.04809 6.95776C2.97798 6.92987 2.91431 6.889 2.86073 6.83749L0.16922 4.25906C0.115571 4.20766 0.0730136 4.14665 0.0439788 4.0795C0.014944 4.01234 7.99437e-10 3.94037 0 3.86769C-7.99437e-10 3.795 0.014944 3.72303 0.0439788 3.65588C0.0730136 3.58873 0.115571 3.52771 0.16922 3.47632C0.222869 3.42492 0.28656 3.38415 0.356656 3.35634C0.426752 3.32852 0.501881 3.31421 0.577753 3.31421C0.653624 3.31421 0.728753 3.32852 0.798849 3.35634C0.868945 3.38415 0.932636 3.42492 0.986286 3.47632L3.26974 5.66384L9.01371 0.16211C9.12206 0.0583128 9.26902 0 9.42225 0C9.57548 0 9.72243 0.0583128 9.83078 0.16211C9.93913 0.265908 10 0.406688 10 0.55348C10 0.700272 9.93817 0.840131 9.82982 0.943928Z"
                  fill="#61AF64"
                />
              </svg>
            </div>
            <div className="selected-hotel-title">{t("ServiceSelected")}
              <span>
            {bookWarnings?.find(item =>
              (item?.package_component_type?.includes("Service")) &&
              item?.destination_row_id === destination?.primary_destination_row_id
            ) ? "⚠︎" : ""}
          </span>
            </div>
            <div className="hotel-action-buttons">
              <button
                className={`hotel-action-btn view-btn ${
                  bookWarnings.length !== 0 ? "show-color" : ""
                }`}
                disabled={bookWarnings.length === 0 && disabled}
                onClick={() => {
                  onClickShowAll();
                  saveBaseData();
                  onClickShowAllType("Service");
                }}
              >
                {t("Show")}
              </button>
              {/* <button
                className="hotel-action-btn remove-btn"
                onClick={() => {
                }}
              >
                {t("Remove")}
              </button> */}
              <button
                className="hotel-action-btn view-btn"
                disabled={disabled}
                onClick={() => {
                  setSelectedComponent(null);
                  openAddService(destination.idx);
                }}
              >
                {t("Add")}
              </button>
            </div>
          </div>
        ) : (
          <AddItemButton onAdd={() => {
            setSelectedComponent(null);
            openAddService(destination.idx)}} />
        )}
      </div>
    </div>
  );
};
export default ComponentRowByDestination;
